import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Product, Products } from '../../shared/classes/product';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductoServiceService {
color: [] = [];
  
  constructor(private http:HttpClient) { }

  obtenerProductosTendencia():Observable<Product[]>{
    return this.http.get<Product[]>(environment.API_SECURITY+'/api/Productos/esTendencia')
  }

  obtenerProductos():Observable<any>{
    return this.http.get<any>(environment.API_SECURITY+'/api/Productos/listaProductos')
  }

  obtenerProductosPaginador(page: number, items: number,body:any):Observable<any>{
    return this.http.post<any>(environment.API_SECURITY+'/api/Productos/listaProductosPaginado/'+page+'/'+ items,body)
  }

  obtenerProductosPrincipal():Observable<any>{
    return this.http.get<any>(environment.API_SECURITY+'/api/productos/listaProductosPrincipal')
  }

  filtrarProductos(data: any,page: number, items: number){
    return this.http.post(environment.API_SECURITY+'/api/Productos/filtro/'+page+'/'+items,data)
  }
  
  buscarProductos(data: any) {
    return this.http.post(environment.API_SECURITY+'/api/productos/buscarProducto',data)
  }
  

  obtenerCotizacion(data: any) {
    return this.http.post(environment.API_SECURITY+'/api/Envios/Cotizacion',data)
  }

  carritoOlvidado(data: any) {
    return this.http.post(environment.API_SECURITY+'/api/CarritosAbandonados',data)
  }

  removeCarritoOlvidado(id: number) {
    const url = `${environment.API_SECURITY}/api/CarritosAbandonados/${id}`;
    return this.http.delete(url);
  }

  liberarProductoInvitado(sku: string, quantity: number) {
    const url = `${environment.API_SECURITY}/api/productos/liberarProductoInvitado/${sku}/${quantity}`;
    return this.http.get(url);
  }

  getReservaProdCarrito(sku: string, quantity: number) {
		return this.http.get<any>(`${environment.API_SECURITY}/api/Productos/reservarProducto/${sku}/${quantity}`);
  }

  getLiberarProdCarrito(sku: string, quantity: number) {
    return this.http.get<any>(`${environment.API_SECURITY}/api/Productos/liberarProducto/${sku}/${quantity}`);
  }
  getReservaProdCarritoInvitado(sku: string, quantity: number) {
		return this.http.get<any>(`${environment.API_SECURITY}/api/Productos/reservarProductoInvitado/${sku}/${quantity}`);
  }

  getLiberarProdCarritoInvitado(sku: string, quantity: number) {
		return this.http.get<any>(`${environment.API_SECURITY}/api/Productos/liberarProductoInvitado/${sku}/${quantity}`);
  }


  fulfilMenu():Observable<any>{
    return this.http.get<any>(`${environment.API_SECURITY}/api/productos/menu`)
  }

  validarBin(bin:any){
    return this.http.post<any>(`${environment.API_SECURITY}/api/ordenes/validatePromotion`,bin)
  }
}
